import http from "./HttpService";

const BASE_SERVICE_URL = "points-service";

export default {
  getCustomerBalance(request) {
    return new Promise((resolve, reject) => {
      http
        .get(BASE_SERVICE_URL + "/customer/balance", request.header)
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  submitReceipts(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/receipts/submit",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  checkReceiptCapping(request) {
    return new Promise((resolve, reject) => {
      http
        .post(BASE_SERVICE_URL + "/receipts/check-capping", request.payload, request.header)
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
};
